import {
  list as _list,
  view as _view,
  update as _update,
  create as _create,
  changeType as _changeType
} from './contacts'
import { list as _typeList } from './types'
import store from '@/store'
import { debounce } from 'lodash'

/**
 * List of contacts
 * @param {Object} requestData
 */
export function list(requestData, param = '') {
  let postId = store.getters['app/account/getPostId']
  return _list(postId, requestData, param)
}

/**
 * View contact
 * @param {*} contactId
 */
export function view(contactId) {
  let postId = store.getters['app/account/getPostId']
  return _view(postId, contactId)
}

/**
 * Create contact
 * @param {*} requestData
 */
export function create(requestData) {
  let postId = store.getters['app/account/getPostId']
  return _create(postId, requestData)
}
/**
 * Update contact
 * @param {*} contactId
 * @param {*} requestData
 */
export function update(contactId, requestData) {
  let postId = store.getters['app/account/getPostId']
  return _update(postId, contactId, requestData)
}

/**
 * Change contact type
 * @param {String} contactId
 * @param {String} typeId
 * @returns {Promise}
 */
export function changeType(contactId, typeId) {
  let postId = store.getters['app/account/getPostId']
  return _changeType(postId, contactId, typeId)
}

/**
 * List contact's types
 */
export function typeList() {
  let postId = store.getters['app/account/getPostId']
  return _typeList(postId)
}

/**
 * Contacts promises by id for loading
 */

let _loadingContacts = {}

/**
 * Debounce contact loading
 */
const debounceLoad = debounce(
  function() {
    let localContacts = _loadingContacts
    _loadingContacts = {}
    let ids = Object.keys(localContacts)
    list({
      filters: {
        id: ids
      }
    }).then(
      data => {
        data.list.forEach(contact => {
          ;(localContacts[contact.id] || []).forEach(param => {
            param.resolve(contact)
            delete localContacts[contact.id]
          })
        })
        Object.keys(localContacts).forEach(contact_id => {
          localContacts[contact_id][0].resolve({})
        })
      },
      error => {
        ids.forEach(id => {
          ;(localContacts[id] || []).forEach(param => {
            param.reject(error)
          })
        })
      }
    )
  },
  200,
  { maxWait: 2000 }
)
/**
 * Load contact by id
 * @param {*} contactId
 */
export function loadContact(contactId) {
  let param = {}
  param.prom = new Promise((resolve, reject) => {
    param.resolve = resolve
    param.reject = reject
  })
  if (!_loadingContacts[contactId]) {
    _loadingContacts[contactId] = []
  }
  _loadingContacts[contactId].push(param)
  debounceLoad()
  return param.prom
}



// WEBPACK FOOTER //
// ./src/apps/crm/contacts/api/index.js